'use client';

import { useEffect, useRef } from 'react';

export default function AdBanner() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const container = document.getElementById('container-d3d331b630a99a2af673f0d609c13677');
    if (container && container.childNodes.length === 0) {
      const script = document.createElement('script');
      script.async = true;
      script.setAttribute('data-cfasync', 'false');
      script.src = 'https://pl31821066.profitableratecpmnetwork.com/d3d331b630a99a2af673f0d609c13677/invoke.js';
      container.appendChild(script);
    }
  }, []);

  return (
    <div className="relative z-10 w-full max-w-6xl flex flex-col justify-center items-center my-4 overflow-hidden">
      <script
        async
        data-cfasync="false"
        src="https://pl31821066.profitableratecpmnetwork.com/d3d331b630a99a2af673f0d609c13677/invoke.js"
      />
      <div id="container-d3d331b630a99a2af673f0d609c13677" ref={containerRef} />
    </div>
  );
}
